import script from "./Groups-View.vue?vue&type=script&setup=true&lang=js"
export * from "./Groups-View.vue?vue&type=script&setup=true&lang=js"

import "./Groups-View.vue?vue&type=style&index=0&id=045f5748&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-045f5748"]])

export default __exports__